// extracted by mini-css-extract-plugin
module.exports = {"HelpText":"HelpText_HelpText__3SuFa","spindindust":"HelpText_spindindust__y2RBI"};